new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
  },
  methods: {
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#cccccc', '#344054', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#cccccc', '#344054', controlSlider);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#cccccc', '#344054', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#cccccc', '#344054', toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const fromInput = document.querySelector('#fromInput');
      const toInput = document.querySelector('#toInput');
      let url = window.location.href;

      if (url.includes('?lp=')) {
        const params = new URLSearchParams(window.location.search)
        const firstParams = params.get('lp');
        const secondParams = params.get('hp');
        fromInput.value = firstParams;
        toInput.value = secondParams;
        fromSlider.setAttribute('value', firstParams);
        toSlider.setAttribute('value', secondParams);
        fillSlider(fromSlider, toSlider, '#cccccc', '#344054', toSlider);
      } else {
        fillSlider(fromSlider, toSlider, '#cccccc', '#344054', toSlider);
        setToggleAccessible(toSlider);
      }

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

      function handleSliderRelease() {
        let from = $('#fromInput').val();
        let to = $('#toInput').val();
        window.location = `?lp=${from}&hp=${to}`;
      }

      $(fromSlider).mouseup(handleSliderRelease);
      $(fromSlider).on('touchend', handleSliderRelease);

      $(toSlider).mouseup(handleSliderRelease);
      $(toSlider).on('touchend', handleSliderRelease);
    },
    buySize() {
      const filterSize = document.querySelector(".product-filter__item--size:not(.product-filter__item--color)");
      if (filterSize) {
        const cloneFilterSize = filterSize;
        const elementDest = document.querySelector("#buy-sizes");
        if (cloneFilterSize && elementDest) {
          elementDest.append(cloneFilterSize);
        }
      } else {
        document.querySelector('.product-list-size').style.display = 'none';
      }
    },
    fixedStyleFilter() {
      const fixedFilter = document.querySelector('.product-filter--fixed');
      const fixedFilterMenu = fixedFilter ? fixedFilter.querySelector('.product-filter__menu') : null;
      const filterItems = document.querySelectorAll('.product-list__filters .product-filter--filters > .product-filter__menu > .product-filter__item');

      if (!fixedFilter || !fixedFilterMenu) return;

      const styleFilter = Array.from(filterItems).find(item => {
        const title = item.querySelector('.product-filter__item__title .product-filter__link');
        return title && title.textContent.trim().toLocaleLowerCase('pt-BR') === 'estilo';
      });

      if (!styleFilter) return;

      styleFilter.classList.add('product-filter__item--fixed');
      fixedFilterMenu.appendChild(styleFilter);
      fixedFilter.classList.add('active');
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    this.fixedStyleFilter();
    this.filterPrice();
    this.buySize();

    const allFilters = document.querySelectorAll('.product-list__filters');
    if (allFilters.length > 0) {
      allFilters.forEach(filter => {
        const items = filter.querySelectorAll('.product-filter__item');

        items.forEach(item => {
          const title = item.querySelector('.product-filter__item__title');
          const submenu = item.querySelector('.product-filter__sub-menu');

          if (title && submenu) {
            // pega altura real do conteúdo
            const height = submenu.scrollHeight;
            submenu.style.height = `${height}px`;
            title.addEventListener('click', () => {
              title.classList.toggle('active');
              submenu.classList.toggle('active');
            });

            title.classList.add('active');
              submenu.classList.add('active');
          }
        });
      });


    }
  },
  watch: {
    menuFilter(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
    listOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const filter = document.querySelector('.product-list__header--filter');
  // Seleciona o header__second--tools que NÃO tem a classe d-lg-none
  const headerTools = Array.from(document.querySelectorAll('.header__second--tools'))
    .find(el => !el.classList.contains('d-lg-none'));
  let filterClone = null;

  if (!filter || !headerTools) return;

  let isCloned = false;

  function handleObserver(entries) {
    entries.forEach(entry => {
      if (window.innerWidth > 991) {
        if (!entry.isIntersecting && !isCloned) {
          // Filtro saiu da tela, cria um botão fake como primeiro filho
          filterClone = document.createElement('div');
          filterClone.classList.add('cloned-filter-btn');
          filterClone.innerText = filter.innerText || 'Filtrar';
          filterClone.style.cursor = 'pointer';
          filterClone.addEventListener('click', function() {
            filter.click();
          });
          headerTools.insertBefore(filterClone, headerTools.firstChild);
          isCloned = true;
        } else if (entry.isIntersecting && isCloned) {
          // Filtro voltou para a tela, remove o fake
          const existingClone = headerTools.querySelector('.cloned-filter-btn');
          if (existingClone) existingClone.remove();
          isCloned = false;
        }
      } else {
        // Em telas menores que 992px
        const header = document.querySelector('.product-list__header');
        const headerSecond = document.querySelector('.header__second');
        const categoryName = document.querySelector('.category-name');
        // Remove o container fake se existir
        const existingClonedHeader = headerSecond ? headerSecond.querySelector('.cloned-header-mobile') : null;
        if (existingClonedHeader) existingClonedHeader.remove();
        isCloned = false;
        // Se o header não está visível, cria o container com os dois elementos
        if (!entry.isIntersecting && header && headerSecond && categoryName) {
          const clonedHeader = document.createElement('div');
          clonedHeader.classList.add('cloned-header-mobile');
          // Botão fake do filtro
          filterClone = document.createElement('div');
          filterClone.classList.add('cloned-filter-btn');
          filterClone.innerText = filter.innerText || 'Filtrar';
          filterClone.style.cursor = 'pointer';
          filterClone.addEventListener('click', function() {
            filter.click();
          });
          // Clone da category-name
          const categoryClone = document.createElement('div');
          categoryClone.classList.add('cloned-category-name');
          categoryClone.innerHTML = categoryName.cloneNode(true).outerHTML;
          // Adiciona ambos ao container
          clonedHeader.appendChild(filterClone);
          clonedHeader.appendChild(categoryClone);
          // Adiciona o container ao headerSecond
          headerSecond.appendChild(clonedHeader);
          isCloned = true;
        }
      }
    });
  }

  const observer = new IntersectionObserver(handleObserver, {
    root: null,
    threshold: 0
  });

  observer.observe(filter);

  // Também escuta resize para garantir o comportamento ao mudar o tamanho da tela
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 991) {
      const existingClone = headerTools.querySelector('.cloned-filter-btn');
      if (existingClone) existingClone.remove();
      isCloned = false;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {

  const stopwatchElement = document.querySelector('.stopwatch');
  if (stopwatchElement) {
    const urlParametro = stopwatchElement.getAttribute('data-url') ? stopwatchElement.getAttribute('data-url').trim() : "";
    const hora = parseInt(stopwatchElement.getAttribute('data-hour'));
    const dia = parseInt(stopwatchElement.getAttribute('data-day'));
    const mes = parseInt(stopwatchElement.getAttribute('data-month'));
    const ano = parseInt(stopwatchElement.getAttribute('data-year'));

    // Verifique se os atributos necessários estão definidos e não são NaN
    if (!isNaN(hora) && !isNaN(dia) && !isNaN(mes) && !isNaN(ano)) {
      const urlAtual = window.location.pathname;
      let dataTermino;
      let cronometro;

      function atualizarCronometro() {
        const agora = new Date().getTime();
        const termino = dataTermino.getTime();
        const tempoRestante = termino - agora;

        if (tempoRestante >= 0) {
          const dias = Math.floor(tempoRestante / (1000 * 60 * 60 * 24));
          const horas = Math.floor((tempoRestante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutos = Math.floor((tempoRestante % (1000 * 60 * 60)) / (1000 * 60));
          const segundos = Math.floor((tempoRestante % (1000 * 60)) / 1000);

          document.getElementById("cronometro").innerHTML =
            dias + "d" + ': ' + horas + "h" + ': ' + minutos + "m" + ': ' + segundos + "s";
        } else {
          document.getElementById("cronometro").innerHTML = "Tempo esgotado!";
          clearInterval(cronometro);
        }
      }

      function mostrarCronometro() {
        dataTermino = new Date(ano, mes - 1, dia, hora, 0);
        cronometro = setInterval(atualizarCronometro, 1000);
      }

      // Mostrar cronômetro em todas as páginas se urlParametro estiver vazio
      if (urlParametro === "" || urlAtual.includes(urlParametro)) {
        mostrarCronometro();
      } else {
        stopwatchElement.style.display = 'none';
      }
    } else {
      console.error('Os atributos data-hour, data-day, data-month ou data-year estão ausentes ou inválidos.');
    }
  } else {
    console.error('Elemento .stopwatch não encontrado.');
  }

  const thirdVitrine = document.querySelector('#product_list3');
  if (thirdVitrine) {
    $('#product_list3').slick({
      arrows: true,
      dots: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4,
          }
        }
      ]
    });

    $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
      Blazy({
        selector: '.lazy-img',
        successClass: 'loaded-img',
        success: function (element) {
          setTimeout(function () {
            var parent = element.previousSibling;
            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
          }, 200);
        }
      });
    });
  }

  var contents = document.querySelectorAll('.about-themes-content');
  contents.forEach(function (el) {

    var dataLenAttr = el.getAttribute('data-length');
    if (!dataLenAttr) return;

    var dataLen = parseInt(dataLenAttr.replace(/[.,]/g, ""), 10);

    if (dataLen <= 500) {
      return;
    }
    el.style.maxHeight = '300px';
    el.style.overflow = 'hidden';

    // Cria botão fora do conteúdo para evitar interferir no HTML interno
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'about-themes-toggle';
    btn.textContent = 'ver mais';
    el.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      var expanded = el.getAttribute('data-expanded') === 'true';
      if (expanded) {
        el.setAttribute('data-expanded', 'false');
        el.style.maxHeight = '300px';
        el.style.overflow = 'hidden';
        btn.textContent = 'ver mais';
      } else {
        el.setAttribute('data-expanded', 'true');
        el.style.maxHeight = 'none';
        el.style.overflow = 'visible';
        btn.textContent = 'ver menos';
      }
    });
  });
})
